import './IncrementalityNote.scss';
import { IncrementalityBeaker } from './IncrementalityBeaker';

// Footer legend explaining the green beaker that marks incrementality-tested
// features. Sits in the bottom-left of the Channel Performance, Marginal
// Returns, Attribution Breakdown, and Channel Rank containers.
export const IncrementalityNote = () => (
  <div className='dtc-commerce-mmm-incrementality-note'>
    <IncrementalityBeaker size={16} />
    <span>
      Channels marked with a green beaker use informative priors based on incrementality studies.
    </span>
  </div>
);
